import React from "react"
import FieldProto_ConditionForm from "../../../../proto/render/condition/condition-form"

import FieldProto from "../../../../proto/field-proto"
import FieldsFactory from "../../../../fields-factory"
import {FieldType} from "../../../../field-type"
import FieldFormElementView from "../../../../render/form-elemnent-view";
import {ConditionType} from "../../../../../model2/conditions/condition-types";

const debug = false
// const debug = "FieldCheckbox_ConditionForm"

export default class FieldCheckbox_ConditionForm extends FieldProto_ConditionForm {

    onChange = (value: boolean)=> {
        this.onChangeType(ConditionType.BOOLEAN_EQUALS)
        this.onChangeValue(value)
    }

    render() {

        let field: FieldProto | null | false = null

        const options: Options = [
            {
                value: false,
                label : "Unchecked",
            },
            {
                value: true,
                label : "Checked",
            }
        ]

        field = FieldsFactory.get({
                        type            : FieldType.DROPDOWN,
                        noValueOption   : false,
                        showMenuMore    : false,
                        options         : options,
                        fieldId         : 'value'
                    })

        debug && console.log(debug, 'render', field)

        return <FieldFormElementView className = "w-140 flex-no-shrink"
                                     field     = {field}
                                     model     = {{type: ConditionType.BOOLEAN_EQUALS, value: this.props.condition.value}}
                                     onChange  = {this.onChange}/>

    }
}
